import { render, staticRenderFns } from "./Snake.vue?vue&type=template&id=7cf78de2&scoped=true&"
import script from "./Snake.vue?vue&type=script&lang=js&"
export * from "./Snake.vue?vue&type=script&lang=js&"
import style0 from "./Snake.vue?vue&type=style&index=0&id=7cf78de2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf78de2",
  null
  
)

export default component.exports